exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".radio-group{margin-bottom:20px}.radio-group label{display:block;margin-bottom:5px}", ""]);
